// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"course"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 2L20 22L4 22L4 2L20 2Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M16 2L12 2L12 7.5L14 6L16 7.5L16 2Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16 2L12 2L12 7.5L14 6L16 7.5L16 2Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 2V22H4L4 2L20 2Z","strokeWidth":"props.strokeWidth"}}]}]};

const CourseIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'course',
    ref,
    icon: element,
  },
));

CourseIcon.displayName = 'CourseIcon';

export default CourseIcon;
